import { Alert } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useUserLocation } from 'Account/hooks';
import RoutePath from 'App/RoutePath';
import { useHistory } from 'react-router-dom';
import { tracking } from 'App/Tracking';
import { multiDestinationLogger } from 'App/Tracking/multiDestinationLogger';
import { LocationForm } from 'Shared/LocationForm';
import Modal from 'Shared/Modal';

import { Wrapper } from './styles';

export enum LocationModalPage {
  Browse = 'browse',
  Practitioner = 'practitioner',
  Book = 'book',
}

export default ({
  page = LocationModalPage.Book,
}: {
  page?: LocationModalPage;
}) => {
  const { t } = useTranslation('book', { keyPrefix: 'locationModal' });
  const history = useHistory();
  const { hasValidLocationData } = useUserLocation();

  return (
    <Modal
      open={!hasValidLocationData}
      modalContent={({ close }) => (
        <Wrapper data-testid="location-modal">
          {page === LocationModalPage.Practitioner ? (
            <Alert
              className="alert"
              variant="warning"
              size="small"
              title={t('alert.title')}
              body={t('alert.text')}
            />
          ) : null}

          <h3>{t('title')}</h3>
          <p>{t('text')}</p>
          <LocationForm
            onSubmitSuccess={({ country, state }) => {
              tracking.track('place-of-residence-updated', {
                country,
                state,
                source: page === LocationModalPage.Book ? 'book' : 'talk',
              });

              void multiDestinationLogger({
                eventName: 'talk-location-set',
              });

              if (page === LocationModalPage.Practitioner) {
                history.push(RoutePath.BookPractitioners);
              }
              close();
            }}
          />
        </Wrapper>
      )}
    />
  );
};
